const codeOperaturs = {
  mts: ['050', '066', '095', '099'],
  kyivstar: ['067', '096', '097', '098', '039'],
  beeline: ['068'],
  life: ['063', '093', '073'],
  utel: ['091'],
  peopleNet: ['092'],
  intertelecom: ['094'],
};
let str = '';
const arr = Object.keys(codeOperaturs);
arr.map((a, b) => {
  if (arr.length > b + 1 || codeOperaturs[a].length < 1) {
    str += `${codeOperaturs[a].join('|')}|`;
  } else {
    str += codeOperaturs[a].join('|');
  }
  return '';
});
export const all = str;



// WEBPACK FOOTER //
// ./src/shared/constants/codeOperators.js